import script from "./BulkOperations.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkOperations.vue?vue&type=script&setup=true&lang=js"

import "./BulkOperations.vue?vue&type=style&index=0&id=54e65582&scoped=true&lang=css"

import exportComponent from "/home/runner/work/payments-cmglobals/payments-cmglobals/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e65582"]])

export default __exports__